import _classCallCheck from "/codebuild/output/src3381625447/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3381625447/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3381625447/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src3381625447/src/qf-app-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PureComponent } from 'react';
export var PersistGate = /*#__PURE__*/function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);
  var _super = _createSuper(PersistGate);
  function PersistGate() {
    var _this;
    _classCallCheck(this, PersistGate);
    _this = _super.apply(this, arguments);
    _this.state = {
      bootstrapped: false
    };
    _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;
      var _persistor$getState = persistor.getState(),
        bootstrapped = _persistor$getState.bootstrapped;
      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).finally(function () {
            return _this.setState({
              bootstrapped: true
            });
          });
        } else {
          _this.setState({
            bootstrapped: true
          });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    };
    return _this;
  }
  _createClass(PersistGate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState.bind(this));
      this.handlePersistorState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof this.props.children === 'function' && this.props.loading) console.error('reduxjs-toolkit-persist: PersistGate expects either a function child or loading prop, but not both. The loading prop will be ignored.');
      }
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.bootstrapped);
      }
      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);
  return PersistGate;
}(PureComponent);
PersistGate.defaultProps = {
  children: null,
  loading: null
};